import router from "../router";

export const getBreadCrumbs = ({
  customer,
  customerDetail,
  checkout,
  buyDataPackage,
  breadcrumbs,
  cusId,
}) => {
  const { history } = router;
  const { current } = history;
  const { meta } = current;
  const { breadcrumb = [] } = meta;

  if (breadcrumbs.includes("CustomerDetail")) {
    const customerBreadCrumb = breadcrumb.filter(
      (x) => x.url.name === "CustomerDetail"
    );

    const customerDetailModel = {
      name: `${customer.name} ${customer.surName}`,
      url: {
        name: "CustomerDetail",
        params: {
          customerNumber: customerDetail,
          customerId: cusId,
        },
      },
    };

    if (customerBreadCrumb.length > 0) {
      const id = breadcrumb.findIndex(
        (x) => x.name === customerBreadCrumb[0].name
      );

      breadcrumb.splice(id, 1, customerDetailModel);
    } else {
      breadcrumb.push(customerDetailModel);
    }
  }

  if (breadcrumbs.includes("BuyDataPackage")) {
    const buyPackBreadCrumb = breadcrumb.filter(
      (x) => x.url.name === "BuyDataPackage"
    );
    const buyPackBreadCrumbModel = {
      icon: "",
      name: "Veri Paketi Talep Et",
      url: {
        name: "BuyDataPackage",
        params: { customerNumber: buyDataPackage, customerId: cusId },
        query: { c: cusId },
      },
    };

    if (buyPackBreadCrumb.length > 0) {
      const id = breadcrumb.findIndex(
        (x) => x.name === buyPackBreadCrumb[0].name
      );
      breadcrumb.splice(id, 1, buyPackBreadCrumbModel);
    } else {
      breadcrumb.push(buyPackBreadCrumbModel);
    }
  }
  if (breadcrumbs.includes("Checkout")) {
    const checkBreadCrumb = breadcrumb.filter((x) => x.url.name === "Checkout");

    const checkBreadCrumbModel = {
      icon: "",
      name: "Checkout",
      url: {
        name: "Checkout",
        params: { packageNumber: checkout },
        query: {
          c: cusId,
        },
      },
    };

    if (checkBreadCrumb.length > 0) {
      const id = breadcrumb.findIndex(
        (x) => x.name === checkBreadCrumb[0].name
      );
      breadcrumb.splice(id, 1, checkBreadCrumbModel);
    } else {
      breadcrumb.push(checkBreadCrumbModel);
    }
  }
};
